import { AxiosResponse } from 'axios';
import { axiosRequest } from '@/common/api/instance';
import { DocumentUploadResponse } from '@/types/api/orders.types';
import { PaginatedResponse, Response as ApiResponse } from '@/types/api/response.types';
import {
  LogReturnData,
  Return,
  ReturnCreatedBy,
  ReturnListItem,
  ReturnPaginationParams,
  ReturnParams,
  ReturnsCount,
  ReturnSite,
  ReturnSiteParams,
  ReturnStatusUpdateBody,
} from '@/types/api/returns.types';

const resource = '/returns';

export const logReturn = async (
  data: LogReturnData,
): Promise<AxiosResponse<ApiResponse<Return>>> => {
  return axiosRequest().post(`${resource}`, data);
};

export const updateReturnStatus = async (
  id: string,
  data: ReturnStatusUpdateBody,
): Promise<AxiosResponse<ApiResponse<Return>>> => {
  return axiosRequest().patch(`${resource}/${id}/status`, data);
};

export const getReturnDetails = async (id: string): Promise<AxiosResponse<ApiResponse<Return>>> => {
  return axiosRequest().get(`${resource}/${id}`);
};

export const getAllReturns = async (
  params: ReturnPaginationParams,
): Promise<AxiosResponse<PaginatedResponse<ReturnListItem[]>>> => {
  return axiosRequest().get(`${resource}`, { params });
};

export const getReturnsCount = async (
  params: ReturnParams,
): Promise<AxiosResponse<ApiResponse<ReturnsCount>>> => {
  return axiosRequest().get(`${resource}/counts`, { params });
};

export const getReturnsStatuses = async (): Promise<AxiosResponse<ApiResponse<string[]>>> => {
  return axiosRequest().get(`${resource}/statuses`);
};

export const getReturnsSites = async (
  params: ReturnSiteParams,
): Promise<AxiosResponse<ApiResponse<ReturnSite[]>>> => {
  return axiosRequest().get(`${resource}/sites`, { params });
};

export const getReturnsCreatedBy = async (
  params: ReturnSiteParams,
): Promise<AxiosResponse<ApiResponse<ReturnCreatedBy[]>>> => {
  return axiosRequest().get(`${resource}/created-by`, { params });
};

export const uploadReturnDocuments = async (
  returnId: string,
  data: FormData,
): Promise<AxiosResponse<ApiResponse<DocumentUploadResponse>>> => {
  return await axiosRequest().post(`${resource}/${returnId}/documents`, data);
};

export const getReturnDoc = async (
  returnId: string,
  documentId: string,
): Promise<AxiosResponse<ApiResponse<DocumentUploadResponse>>> => {
  return axiosRequest().get(`${resource}/${returnId}/documents/${documentId}`);
};
